export const WeddingPage = () => {
    return (
        <>
            <h1>Wedding page</h1>
        </>
    )
}